import React from "react";

const LoginModal = () => {
  return (
    <div>
      <p>Please log in or create an account to utilize this feature.</p>
    </div>
  );
};

export default LoginModal;
